import { getBrowserGlobals } from './globals';

export const logErrorResponse = (error: string) => {
  const browserGlobals = getBrowserGlobals();
  if (browserGlobals != null) {
    browserGlobals.window.elasticApm?.captureError(error);
  }
};
